import { Component, OnInit } from '@angular/core';
// import {isNullOrUndefined} from 'util';
import { ActivatedRoute, NavigationEnd, Router, RouterEvent } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {
  static readonly ROUTE_DATA_BREADCRUMB = 'breadcrumb';
  readonly home = { icon: 'pi pi-home', url: 'admin' };
  menuItems: any;

  constructor(private router: Router, private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    this.menuItems = this.createBreadcrumbs(this.activatedRoute.root)
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => this.menuItems = this.createBreadcrumbs(this.activatedRoute.root));
  }

  // this.router.events.pipe(
  //     filter(event => event instanceof NavigationEnd)
  //   )
  //     .subscribe((event: any) => {
  //       // console.log(event.url);
  //       const url = event.url.split('/admin')[1];
        
  //       const routes = url.split('/');
  //       // const routeList = routes.shift();
  //       // console.log(routeList);
        
  //       const breadcrumbs = routes.map((route: any) => {
  //         return { label: route, link: event.url }
  //         // if (route !== 'admin') {
  //         // } else {
  //         //   return { label: '/' }
  //         // }
  //       })
  //       this.bread = breadcrumbs;
  //       // console.log(breadcrumbs);
        
  //     });

  private createBreadcrumbs(route: ActivatedRoute, url: string = '', breadcrumbs: any[] = []): any {
    const children: ActivatedRoute[] = route.children;
    // console.log(children);


    if (children.length === 0) {
      return breadcrumbs;
    }

    for (const child of children) {
      const routeArray: any = child.snapshot.url.shift();
      const routeURL: string = routeArray.map((segment: any) => segment.path).join('/');
      if (routeURL !== '') {
        url += `/${routeURL}`;

      }
      console.log(routeURL);

      const label =routeURL // BreadcrumbComponent.ROUTE_DATA_BREADCRUMB ? child.snapshot.data[BreadcrumbComponent.ROUTE_DATA_BREADCRUMB] : routeURL;
      // console.log(label);

      if (label !== undefined && label !== null) {
        breadcrumbs.push({ label, url });
      }
      // console.log(child, url, breadcrumbs);

      return this.createBreadcrumbs(child, url, breadcrumbs);

    }
    console.log(breadcrumbs);
  }
}